import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from './api.service';

@Injectable()
export class ParameterService {

  private API_URL = environment.apiUrl;
  private PARAM_URL = environment.parameterApiUrl;
  public BTM_URL: string = environment.btmApiUrl;


  constructor(private http: HttpClient) {

  }

  getHotelCitiesForDropdown(query) {
    let param = query ? ('?'+query ): '';
    return this.http.get<ApiResponse>(this.PARAM_URL + `/parameters/hotel/cities${param}`);
  }

  getCities(query?) {
    let param = query ? ('?'+query ): '';
    return this.http.get<ApiResponse>(this.PARAM_URL + `/parameters/hotel/cities${param}`);
  }


  getHotelCities(param) {
    return this.http.post<ApiResponse>(this.PARAM_URL + `/parameters/hotel/cities/validate`, param);
  }

  getHotels(param) {
    return this.http.get<ApiResponse>(`${this.BTM_URL}/btm/hotels/searchHotelsWithMatch?${param}`);

  }

  getCountries(param) {
    return this.http.get<ApiResponse>(this.PARAM_URL + `/parameters/country${param ? ('?' + param.toString()) : ''}`);
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/utils/services/parameter.service.ts